import { UserType } from '../user.type';
import { ScimScope } from './scim.scope';

export const SCIM_SCOPE_USER_TYPE: Record<ScimScope, UserType> = {
    [ScimScope.Employee]: UserType.Employee,
    [ScimScope.Customer]: UserType.Client,
    [ScimScope.Contractor]: UserType.Subcontractor,
};
